import { toSafeObjectOrNull } from './toSafeObjectOrNull.js';

export const toPlainText = (value, { pretty = false } = {}) => {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    return value
      .map((entry) => {
        return toPlainText(entry, { pretty });
      })
      .filter(Boolean)
      .join('\n');
  }

  const objectValue = toSafeObjectOrNull(value);

  if (!objectValue) {
    return '';
  }

  if (typeof objectValue.text === 'string') {
    return objectValue.text;
  }

  if (typeof objectValue.content === 'string') {
    return objectValue.content;
  }

  if (Array.isArray(objectValue.content)) {
    return toPlainText(objectValue.content, { pretty });
  }

  try {
    return pretty ? JSON.stringify(objectValue, null, 2) : JSON.stringify(objectValue);
  } catch {
    return '';
  }
};
